module.exports = __webpack_public_path__ + "static/media/icons_Bilan Tendinopathie (Membres inférieurs).14805cad.svg";